module.exports = __webpack_public_path__ + "media/svg-new/f-setting-ee457f27.svg";